import { Trans } from "@lingui/macro"
import { useQuery } from "@tanstack/react-query"
import { Button } from "@src/components/atoms/Button"
import { useCookieConsent } from "@src/hooks/useCookieConsent"
import { useCommunityId } from "@src/hooks/useCommunityId"
import { getCommunityAboutQuery } from "@src/api/community"

const DEFAULT_TERMS_URL = "https://babele.co/terms-of-use/"

export const CookieConsent = () => {
  const { consent, accept, reject } = useCookieConsent()
  const communityId = useCommunityId()
  const { data: community } = useQuery(getCommunityAboutQuery(communityId))

  const termsUrl = community?.termsAndConditionLink || DEFAULT_TERMS_URL

  if (consent !== null) return null

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-lg border border-pearl-lighter bg-white p-5 shadow-realistic-medium-medium-elevation sm:w-auto"
    >
      <p className="text-paragraph-medium text-pearl-dark">
        <Trans id="cookie_consent_message">
          We use cookies for analytics, including session recordings, to
          improve our service. Read our{" "}
          <a
            href={termsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline hover:text-blue-dark"
          >
            Terms of Use
          </a>
          .
        </Trans>
      </p>
      <div className="mt-4 flex gap-3">
        <Button variant="secondary" small className="flex-1" onClick={reject}>
          <Trans id="cookie_consent_reject">Necessary only</Trans>
        </Button>
        <Button variant="secondary" small className="flex-1" onClick={accept}>
          <Trans id="cookie_consent_accept">Accept</Trans>
        </Button>
      </div>
    </div>
  )
}
